import React, { useState, useEffect } from 'react';
import { DependenteEntidade } from '@entidades';
import { Alert, Box } from '@intech/web-ui';
import LoadingComponent from '../LoadingComponent';
import { DependenteService } from '@services';
import { DateFix } from '@helpers';

interface IProps {
  SqPlano: number;
}

export const Dependentes: React.FC<IProps> = ({
  SqPlano
}) => {
  const [Dependentes, setDependentes] = useState<Array<DependenteEntidade> | undefined>(new Array<DependenteEntidade>());

  const [Loading, setLoading] = useState<boolean>(true);
  const [Erro, setErro] = useState<string>("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const Dependentes = await DependenteService.BuscarPorPlano(SqPlano);
        setDependentes(Dependentes);
      }
      catch (err) {
        const e: any = err;
        const error = e.response ? e.response.data : e;
        setErro(error);
      }
      finally {
        setLoading(false);
      }
    })();
  }, [SqPlano]);

  return (
    <>
      {Loading && <LoadingComponent />}

      {!Loading && Erro && <Alert type={"danger"}>{Erro}</Alert>}

      {!Loading && !Erro && !Dependentes && <Alert type={"info"}>{"Nehuma informação disponível no momento."}</Alert>}

      {!Loading && !Erro && Dependentes && <>
        {Dependentes.length > 0 && <>
          <Box title={"Beneficiários"}>
            <div className={"table-responsive"}>
              <table className={"table table-striped table-sm"}>
                <thead>
                  <tr>
                    <th>{"Grau de Parentesco"}</th>
                    <th>{"Nome"}</th>
                    <th>{"Sexo"}</th>
                    <th>{"Data de Nascimento"}</th>
                    <th>{"CPF"}</th>
                    <th>{"Atualizado em"}</th>
                  </tr>
                </thead>
                <tbody>
                  {Dependentes.map((dependente: DependenteEntidade, index: number) => {
                    const cor = index % 2 === 0 ? "table-active" : "";
                    return (
                      <tr key={index} className={cor}>
                        <td>
                          {dependente.DS_GRAU_PARENTESCO}
                        </td>
                        <td>
                          {dependente.NO_PESSOA}
                        </td>
                        <td>
                          {dependente.IR_SEXO}
                        </td>
                        <td>
                          {DateFix(dependente.DT_NASCIMENTO)}
                        </td>
                        <td>
                          {dependente.NR_CPF}
                        </td>
                        <td>
                          {DateFix(dependente.DT_INCLUSAO)}
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </Box>
        </>}

        {Dependentes.length === 0 && <Alert type={"info"}>{"Não há dependentes cadastrados para esse plano."}</Alert>}
      </>}
    </>
  );
}
